import React from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-query";
import useOrganizationContext from "hooks/useOrganizationContext";
import { DuplicateChecklists } from "./modals/duplicate-checklists";
import { useChecklistsBatchActionsToasts } from "../hooks/useChecklistsBatchActionsToasts";
import { checklistTriggerAction } from "../utils/trigger-action/trigger-action";
import { LinkWeezTagToChecklists } from "./modals/link-weeztag";

export const ChecklistsBatchActionsModals = ({
	openedType,
	onCancel,
	onSuccess,
	checklistsIds,
	selectedCheckpointsStatuses
}) => {
	const organization = useOrganizationContext();
	const { success, error } = useChecklistsBatchActionsToasts();

	const { mutate, isLoading } = useMutation(checklistTriggerAction, {
		onSuccess: (_, { type }) => {
			success(type);
			onSuccess();
		},
		onError: (_, { type }) => {
			error(type);
			onCancel();
		}
	});

	const handleSubmit = data => {
		mutate({
			organizationId: organization?.id(),
			type: data.actionType,
			data,
			selectedCheckpointsStatuses
		});
	};

	return (
		<>
			{openedType === "DUPLICATE_CHECKLISTS_MODAL" && (
				<DuplicateChecklists
					isSubmitting={isLoading}
					onCancel={onCancel}
					onSubmit={handleSubmit}
					checklistsIds={checklistsIds}
				/>
			)}
			{openedType === "LINK_WEEZ_TAG_MODAL" && (
				<LinkWeezTagToChecklists
					isSubmitting={isLoading}
					onCancel={onCancel}
					onSubmit={handleSubmit}
					checklistsIds={checklistsIds}
				/>
			)}
		</>
	);
};

ChecklistsBatchActionsModals.propTypes = {
	openedType: PropTypes.string,
	onCancel: PropTypes.func,
	onSuccess: PropTypes.func,
	checklistsIds: PropTypes.arrayOf(PropTypes.any),
	selectedCheckpointsStatuses: PropTypes.arrayOf(PropTypes.any)
};

ChecklistsBatchActionsModals.defaultProps = {
	openedType: null,
	onCancel: () => {},
	onSuccess: () => {},
	checklistsIds: [],
	selectedCheckpointsStatuses: []
};
